export const refreshTokenDelay = 600000;

export const APP_ENDPOINTES = {
  NOTIFICATIONS: '/creditEntreprise/notifications/getNotifications',
  REFRESH_TOKEN: '/creditEntreprise/authentication/refreshToken',
};
